import { render } from "./import-exportersindia.vue?vue&type=template&id=4a2083b8&scoped=true"
import script from "./import-exportersindia.vue?vue&type=script&lang=js"
export * from "./import-exportersindia.vue?vue&type=script&lang=js"

import "./import-exportersindia.vue?vue&type=style&index=0&id=4a2083b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2083b8"]])

export default __exports__